<template>
  <div class="quality-recommend" ref="container">
    <div class="title acea-row row-center-wrapper">
      <div class="line"></div>
      <div class="name">
        <span class="iconfont" :class="icon"></span>{{ name }}
      </div>
      <div class="line"></div>
    </div>
    <Good-list :good-list="goodsList" :is-sort="false" :type="type"></Good-list>
    <Loading :loaded="loadend" :loading="loading"></Loading>
  </div>
</template>
<script>
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import { getTaskList } from "@api/store";
import { getGroomList } from "@api/store";
import Loading from "@components/Loading";
export default {
  name: "HotNewGoods",
  components: {
    GoodList,
    Loading
  },
  props: {},
  data: function() {
    return {
      goodsList: [],
      name: "",
      icon: "",
      type: 0,
      RecommendSwiper: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      loadTitle: "",
      loading: false,
      loadend: false,
      where: {
        page: 1,
        limit: 20,
        type: 2
      }
    };
  },
  created() {
    let type = this.$route.params.type;
    this.type = type;
  },
  mounted: function() {
    this.loadend = false;
    this.loading = false;
    this.titleInfo();
    this.getIndexGroomList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getIndexGroomList();
    });
  },
  methods: {
    titleInfo: function() {
      let type = this.$route.params.type;
      if (type === "1") {
        this.name = "精品推荐";
        this.icon = "icon-jingpintuijian";
        document.title = "精品推荐";
      } else if (type === "2") {
        this.name = "热门商品";
        this.icon = "icon-remen";
        document.title = "热门商品";
      } else if (type === "3") {
        this.name = "首发新品";
        this.icon = "icon-xinpin";
        document.title = "首发新品";
      } else {
        this.name = "热门商品";
        this.icon = "icon-remen";
        document.title = "热门商品";
      }
    },
    getIndexGroomList: function() {
      let that = this;
      if (that.loading) return;
      if (that.loadend) return;
      that.loading = true;
      let type = this.$route.params.type;
      that.where.type = 2; //热门商品
      if (type === "1") {
        //精品推荐
        that.where.type = 1;
      } else if (type === "3") {
        //首发新品
        that.where.type = 3;
      }
      let q = that.where;
      getGroomList(q)
        .then(res => {
          that.loading = false;
          that.goodsList.push.apply(that.goodsList, res.data.list);
          that.loadend = res.data.list.length < that.where.limit; //判断所有数据是否加载完成；
          that.where.page = that.where.page + 1;
        })
        .catch(function(res) {
          this.$dialog.toast({ mes: res.msg });
        });
    }
  }
};
</script>
